export default [
    // French
    'fr/home/home',
    'fr/home/welcome',
    'fr/user/user',
    'fr/form/form',
    'fr/form/components',

    // English
    'en/home/home',
    'en/form/form',
    'en/form/components',
    'en/home/welcome',
    'en/user/user',
]



// WEBPACK FOOTER //
// ./src/lang/default/conf.js